import { Option } from '@inrev/core';
import { commercialSuretyBondTypeSchema, contractCategoryBondTypeSchema, contractSuretyTypeSchema } from '../enums.mjs';

const isContractSuretyBondType = (bondType) => Option.isSome(bondType) && contractSuretyTypeSchema.safeParse(bondType).success;
const isContractCategoryBondType = (bondType) => Option.isSome(bondType) && contractCategoryBondTypeSchema.safeParse(bondType).success;
const isCommercialSuretyBondType = (bondType) => Option.isSome(bondType) && commercialSuretyBondTypeSchema.safeParse(bondType).success;

export { isCommercialSuretyBondType, isContractCategoryBondType, isContractSuretyBondType };
